import { render, staticRenderFns } from "./BlockType110.vue?vue&type=template&id=ea912342&scoped=true"
import script from "./BlockType110.vue?vue&type=script&lang=ts"
export * from "./BlockType110.vue?vue&type=script&lang=ts"
import style0 from "./BlockType110.vue?vue&type=style&index=0&id=ea912342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea912342",
  null
  
)

export default component.exports